import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

export function* getQAS() {
    yield* takeEvery("QAS/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {
                console.log('saga')
                return request.get(`${config.apiEndpoint}/api/cs/v2/qas${id ? `/${id}` : ''}`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { qas, qa } = result;
                if (action.id) {
                    yield put({ type: 'QA/SET', qa });
                } else {
                    yield put({ type: 'QAS/SET', qas });
                }
            } else {
                yield put({
                    type: 'QAS/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'QAS/FETCH_FAILED',
                e
            });
        }
    });
}


// WEBPACK FOOTER //
// ./src/redux-sagas/sagas/qas.js